import { FC } from 'react'
import cn from 'classnames'
import type { TaskTrackerTaskHistoryEvent } from '../../../../../store/taskTracker.types'
import {
  buildTaskHistoryEventContent,
  formatTaskHistoryDate,
  formatTaskHistoryTime,
  getTaskHistoryAutomationAction,
  getTaskHistoryAutomationBadgeLabel,
  isTaskHistoryAutomationEvent,
  resolveTaskHistoryEventLabel,
  TaskTrackerTaskHistoryLookups,
} from '../../../../../lib/taskTrackerTaskHistory.utils'
import classes from './index.module.css'

type TaskHistoryItemProps = {
  event: TaskTrackerTaskHistoryEvent
  lookups: TaskTrackerTaskHistoryLookups
}

const TaskHistoryItem: FC<TaskHistoryItemProps> = ({ event, lookups }) => {
  const actorName = event.actor
    ? event.actor.name?.trim() || 'неизвестно'
    : 'система'
  const automationAction = getTaskHistoryAutomationAction(event.eventData)
  const isAutomation = isTaskHistoryAutomationEvent(event)
  const eventLabel = resolveTaskHistoryEventLabel(event)

  return (
    <article className={classes.timelineItem}>
      <div className={classes.timelineRail} aria-hidden>
        <span
          className={cn(classes.timelineDot, {
            [classes.timelineDotAutomation]: isAutomation,
          })}
        />
      </div>
      <div
        className={cn(classes.timelineCard, {
          [classes.timelineCardAutomation]: isAutomation,
        })}
      >
        <div className={classes.cardTimeRow}>
          <div className={classes.timeMeta}>
            {formatTaskHistoryDate(event.createdAt)} ·{' '}
            {formatTaskHistoryTime(event.createdAt)}
          </div>
          {isAutomation && automationAction ? (
            <span
              className={classes.automationBadge}
              title={eventLabel || undefined}
            >
              {getTaskHistoryAutomationBadgeLabel(automationAction)}
            </span>
          ) : (
            <span className={classes.eventLabel}>{eventLabel}</span>
          )}
        </div>
        <div className={classes.cardBody}>
          {buildTaskHistoryEventContent(event, lookups)}
          <span className={classes.metaAuthor}>
            {isAutomation ? 'Инициатор' : 'Автор'}: {actorName}
          </span>
        </div>
      </div>
    </article>
  )
}

export default TaskHistoryItem
